export default {
  data() {
    return {
      labels: [],
      numbers: [],
      colors: ['#1f568c', '#f57a64'],
    };
  },
  methods: {
    percentsFormat(value, canvas) {
      let sum = 0;
      const dataArr = canvas.chart.data.datasets[0].data;
      dataArr.forEach((data) => { sum += data; });
      let percentage = `${Math.ceil((value * 100) / sum)}`;
      if (Math.ceil((value * 100) / sum) > 10 && this.chart === 'pie') {
        percentage += '%';
      }
      return percentage;
    },
    convertData() {
      this.labels = Object.keys(this.graphicData);
      this.numbers = Object.values(this.graphicData);
    },
    createColors() {
      this.colors = [];
      for (let i = 0; i < this.labels.length; i += 1) {
        this.colors.push(`rgba(${this.getRandom()}, ${this.getRandom()}, ${this.getRandom(120)}, 0.8)`);
      }
    },
    getRandom(min = 0, max = 255) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/graphics.js